import logger from "../../utils/LoggerFrontend";
import webAPIUtils from "../../utils/WebAPIUtils";

export function callWebUtils(context, methodName, args) {
  return webAPIUtils[methodName](...args)
    .then((result) => {
      if (result && result.meta && result.meta.error === true) {
        logger.log("error:Actions:callWebUtils:then", "Then:" + methodName, { result });
        return context.failed(result);
      }
      if (result && result.error === true) {
        logger.log("error:Actions:callWebUtils:then", "Then:" + methodName, { result });
        return context.failed(result);
      }
      context.completed(result, ...args);
    })
    .catch((err) => {
      logger.log("error:Actions:callWebUtils:catch", "Then:" + methodName, { err });

      const error = err?.responseJSON || err;
      const errorMessage = error?.meta?.message || error?.message || "Unknown error";

      context.failed(errorMessage);
    });
}
